import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { useFileBufferContext } from '@lyearn/lygo-core';
import { FileInput, useSnackbar } from '@lyearn/ui';

import { setNodeAttrs } from '../../utils';
import { ReplaceInputProps } from './types';

export const ReplaceInputComponent: React.FC<ReplaceInputProps> = (props) => {
  let { view, selectedNode, triggerClick, pos } = props;
  let { fileBuffer } = useFileBufferContext();
  const [inputRef, setInputRef] = useState<HTMLInputElement | null>(null);
  const { showErrorSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const currenInputType = useMemo(() => {
    const nodes = (view.state as any).config.schema.nodes;
    switch (selectedNode.type) {
      case nodes.image:
        return 'image/*';
      case nodes.video:
        return 'video/*';
      case nodes.embed:
        return '.pdf';
      case nodes.file:
        return '';
      case nodes.audio:
        return 'audio/*';
    }
  }, [selectedNode.type, view.state]);

  const handleInputChange = useCallback(
    (event: any) => {
      if (event.target.files[0]) {
        const fileKey = fileBuffer?.addFile(event.target.files[0]);
        try {
          setNodeAttrs(view, pos, {
            id: selectedNode.attrs.id,
            file: fileKey,
          });
        } catch (e) {
          fileBuffer?.removeFile(fileKey as string);
        }
      }
    },
    [fileBuffer, pos, selectedNode, view],
  );

  const onFileSelectErrorHandler = useCallback(() => {
    showErrorSnackbar({
      message: t('Common:FileTypeNotAllowedToBeUploaded', { accept: currenInputType }),
    });
  }, [showErrorSnackbar, currenInputType, t]);

  useEffect(() => {
    if (inputRef) {
      inputRef.click();
    }
  }, [triggerClick, inputRef]);

  return (
    <FileInput
      ref={setInputRef}
      accept={currenInputType}
      className="hidden"
      onChange={handleInputChange}
      onFileSelectError={onFileSelectErrorHandler}
    />
  );
};
